/**
 * AutoFilters class
 * @private
 */
/* eslint-disable */
export class AutoFilters {
}
